import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { analytics } from './utils/analytics'
import { GA_CONFIG } from './config/analytics'
import { createGtag } from 'vue-gtag'

import './style.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

// 初始化Google Analytics
app.use(createGtag({
  tagId: GA_CONFIG.MEASUREMENT_ID,
  config: GA_CONFIG.CUSTOM_CONFIG,
  resource: {
    inject: true,
    preconnect: true
  },
  pageTracker: {
    router,
    sendPageView: true
  }
}))

// 初始化analytics管理器
analytics.initialize().then(() => {
  // 跟踪初始页面访问
  analytics.trackPageView()
})

app.mount('#app')
